import { resolvePageHost } from './hosts';

export const PAGE_HOST = resolvePageHost(window.location.hostname);

export const API_ENDPOINT = PAGE_HOST.apiHosts.rental;
export const PAYMENT_API_ENDPOINT = PAGE_HOST.apiHosts.payment;
export const AUTH_API_ENDPOINT = PAGE_HOST.apiHosts.auth;
export const AUTH_API_CLIENT_ID = process.env.REACT_APP_AUTH_API_CLIENT_ID;
